export default __webpack_public_path__ + "static/media/msgboard.3c9965b6.png";